import PropTypes, { object } from "prop-types";

export const dateRangePickerProps = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.arrayOf(PropTypes.string),
  status: PropTypes.oneOf(["warning", "error"]),
  defaultValue: PropTypes.arrayOf(object),
  size: PropTypes.oneOf(["small", "middle", "large", "max"]),
};
